import { Injectable } from '@angular/core';
import { StepsService } from '@app/shared/services/steps/steps.service';
import { map } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { BaseApiService } from '../base-api.service';
import { environment } from '@env/environment';
import {
  PropostaPostResponse,
  PropostaRequest,
  PropostasResponse,
} from './proposta.models';

@Injectable({
  providedIn: 'root',
})
export class PropostasService extends BaseApiService {
  constructor(
    private stepsService: StepsService,
    private authService: AuthService
  ) {
    super('proposta');
  }

  getProposta() {
    return this.get<PropostasResponse>().pipe(map((response) => response.data));
  }

  getPropostaStatus(propostaId: number) {
    return this.get<any>(`${propostaId}/status`);
  }

  getServicosAdicionais(propostaId: number) {
    return this.get<any>(`${propostaId}/servicos-adicionais`);
  }

  decodeLink(token: string) {
    return this.get<any>(`decode-link/${encodeURIComponent(token)}`);
  }

  getTermosOrganizacao() {
    return this.http.get<any>(`${environment.BASE_API_URL}/integracoes-carsubs`).pipe(
      map((response) => {
        const item = response?.data?.items?.[0] || {};
        return (
          item.TermosCondicoes ||
          item.termosCondicoes ||
          item.TermoCondicoes ||
          sessionStorage.getItem('termosCondicoes') ||
          ''
        );
      })
    );
  }

  postProposta() {
    const codigoSegmentacao = sessionStorage.getItem('segmentation') ?? null;
    const empresa = sessionStorage.getItem('empresa') ?? null;

    const { CodigoGrupo, CodigoModelo, Grupo, Contrato, UnidadeSelecionada, CodigoTarifaAssinatura, PropostasItensEquipamento } =
      this.stepsService.getSteps();
    const codigoTarifaAssinaturaSelecionada = Contrato?.franquia || CodigoTarifaAssinatura;

    const { codigoCliente, nome, telefone, email } =
      this.authService.getUserData();

    const servicosAdicionais = Contrato?.servicosAdicionais.map((servico) => {
      return {
        CodigoServicoAdicional: servico.CodigoServicoAdicional,
        ValorServicoAdicional: servico.Valor,
        Quantidade: 1,
        ValorUnitario: servico.Valor,
        Flexivel: servico.Flexivel,
        QuantidadeVezesCobrar: servico.QuantidadeVezesCobrar,
        ServicoAdicional: {
          CodigoServicoAdicional: servico.CodigoServicoAdicional,
          Descricao: servico.ServicoAdicional,
        },
      };
    });
    const data = {
      CodigoEmpresa: empresa ?? UnidadeSelecionada?.CodigoEmpresa,
      CodigoRevisao: '1',
      CodigoPropostaSituacao: '1',
      ClienteEfetivado: 'S',
      PropostaPortalCarsubs: 'S',
      CodigoCliente: codigoCliente,
      CodigoCategoria: '11',
      Objetivo: null,
      DataAbertura: new Date(),
      PrazoEntrega: new Date(),
      ValorNominal: (Contrato?.valorTotalMensal ?? 0) * (Contrato?.duracao ?? 1),
      TipoContrato: 'C',
      AceitarTermosCondicoes: Contrato?.aceitarTermosCondicoes,
      Observacao: `Proposta gerada pelo Portal Carsubs.`,
      NomeContato: nome,
      EmailContato: email,
      TelefoneContato: telefone,
      PropostaItens: [
        {
          CodigoCor: Contrato?.cor,
          CodigoGrupo,
          CodigoModelo,
          CodigoMunicipioEmplacamento: UnidadeSelecionada?.CodigoMunicipio,
          UFEmplacamento: UnidadeSelecionada?.Estado,
          Cor: {
            Descricao: Contrato?.veiculo?.Cores?.find(
              (cor) => cor.CodigoCor === Contrato?.cor
            )?.Cor,
          },
          Grupo: {
            Descricao: Grupo,
          },
          Modelo: {
            Descricao: Contrato?.veiculo?.Modelo,
          },
          Quantidade: '1',
          UnidadeTempoContratoPorPlaca: 'M',
          DuracaoContratoPorPlaca: Contrato?.duracao,
          CodigoVeiculosFinalPlaca: Contrato?.codigoVeiculoFinalPlaca,
          Tarifa: {
            ValorPeriodoVeiculo: Contrato?.valorLocacao,
            PeriodoTarifa: Contrato?.duracao,
            CodigoLocalRetirada: UnidadeSelecionada?.CodigoLocalRetirada,
            FranquiaKmRodado: Contrato?.franquiaValorKm,
            ValorKmRodado: Contrato?.valorKmRodado,
            CodigoTarifaAssinatura: codigoTarifaAssinaturaSelecionada,
          },
          Equipamentos: PropostasItensEquipamento,
          ServicosAdicionais: servicosAdicionais,
        },
      ],
      PropostaDetalhe: {
        CodigoProposta: null,
        CodigoRevisao: null,
        CodigoSegmentacaoProduto: codigoSegmentacao,
      },
      PropostaDadosAdicionais: {
        CodigoProposta: null,
      },
    } as PropostaRequest;

    return this.post<PropostaPostResponse>(data);
  }
}
